// import React, { useContext, useEffect, useState } from 'react'
// import { useRouter } from 'next/router'
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import Layout from "../components/Layout";
// import {UserContext} from '../components/UserContext'
// import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
// import Link from "next/link";
// import Scrollspy from 'react-scrollspy';
// import Scroll from "./Scroll";
// import Modal from "react-modal";
// import OtpModal from "../components/OtpModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Carousel from 'react-multi-carousel';
// import Select from 'react-select'
import { Fade } from "./../components/Animation";
import "animate.css";
import Footer from "../components/Footer";
import { FaqCharger } from "../components/Faq";
import Carousel from 'react-multi-carousel';
import FormGstEstimate from "../components/FormGetEstiamte";

const responsive = {
  Desktop: {
    breakpoint: { max: 4000, min: 640 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1
  }
}

const Charger = () => {
  return (
    <Layout title="Charger">
      <section className="bg-white pt-20">
        <div className="grid place-items-center home charger-banner">
          <div className="p-6 container m-auto md:px-12 xl:px-24">
            <div className="">
              <div className="">
                <div className="flex flex-col justify-center">
                  <h1 className="text-4xl xxs:text-5xl md:text-6xl font-primarySemiBold text-white">
                    Electric Vehicle Charger
                  </h1>
                  <p className="text-base xxs:text-lg md:text-xl 2xl:text-2xl text-gray-100 py-2 font-primaryRegular lg:max-w-lg">
                    Convenient, Reliable & Affordable
                  </p>
                  <div>
                    <a
                      href=""
                      className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-12 py-2 my-4 text-base md:text-lg 2xl:text-xl"
                    >
                      Get a Quote
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="xl:px-20 bg-white">
        <section className="py-8 md:py-20">
          <div className="sm:p-6 2md:p-4 xl:px-20 md:container md:m-auto grid 2md:grid-cols-2 gap-4 2md:gap-10">
            <div className="xl:pr-20 p-6 xl:p-0 my-auto">
              <h1 className="text-xl xxs:text-2xl tracking-wide capitalize text-primary font-primaryMedium">
                Introduction
              </h1>
              <div className="border bg-primary border-primary my-3 w-12"> </div>
              <h1 className="text-2xl xxs:text-3xl sm:text-4xl md:text-5xl xl:text-5xl text-titleColor font-primaryMedium">EV Charging
                <span className="font-primaryBold"> Solutions </span>
              </h1>
              <p className="text-titleColor py-4 text-base xxs:text-xl font-primaryMedium">
                Solar Quote offers energy efficient EV Charging solutions. There are two types of EV
                Chargers: AC chargers and DC chargers. Considering the standard electrical connection
                at home, we would recommend to go with AC chargers for residential EV Chargers.
              </p>
            </div>

            <Fade triggerOnce delay={500}>              
              <div className="xl:px-10 px-6 my-auto">
                <img src="./images/ev-charging.png" className="object-contain mx-auto" />
              </div>
            </Fade>
          </div>
        </section>
      </div>

      <div className="xl:px-28 xl:pb-14 bg-white">
        <div className="p-6 2md:p-4 container m-auto">
          <h1 className="pb-6 sm:pb-12 mx-auto xxs:text-center text-2xl xxs:text-3xl sm:text-4xl 2md:text-5xl text-titleColor font-primaryMedium">How do electric
            <span className="font-primaryBold"> chargers work?</span></h1>
            <Fade triggerOnce delay={500}>            
            <div className="bg-gray-100 sm:m-6 md:p-0">
              <img src="./images/charger-work.png" className="p-6 sm:p-14 object-contain" />
            </div>
          </Fade>
        </div>
      </div>

      {/* <div className="xl:px-28 xl:pb-24 bg-white">
        <div className="p-6 2md:p-4 container m-auto">
        <h1 className="xxs:mx-auto xxs:text-center lg:w-3/4 text-2xl xxs:text-3xl sm:text-4xl 2md:text-5xl text-titleColor font-primaryMedium">Take back control of your 

<span className="font-primaryBold"> energy with confidence   </span></h1>
<div>
              <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row pt-8 xxs:pt-12 2md:pt-20 sm:px-8">
              <div className="mx-auto sm:mx-0 w-1/3 sm:w-1/5">
<img src="./images/energy-1.png" className="object-contain rounded-full"/>
</div>
<div className="sm:w-4/5 sm:pl-6 xl:pl-20 container m-auto">
<h1 className="text-xl xxs:text-2xl 2md:text-3xl text-titleColor font-primarySemiBold">
Hassle free Installation
</h1>
<p className="text-bodyColor py-2 sm:py-4  text-sm xxs:text-base sm:text-xl font-primaryMedium">
From helping you choose the right panel to installation, we will do all the heavy lifting for you. You can further manage your solar system on your device, and get help from our support team whenever you please.</p>
</div>
              </div>
              <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row-reverse pt-8 xxs:pt-12 2md:pt-20 sm:px-8">
              <div className="mx-auto sm:mx-0 w-1/3 sm:w-1/5">
<img src="./images/energy-2.png" className="object-contain rounded-full"/>
</div>
<div className="sm:w-4/5 sm:pr-6 xl:pr-20 container m-auto">
<h1 className="text-xl xxs:text-2xl 2md:text-3xl text-titleColor font-primarySemiBold">
Custom Solar
</h1>
<p className="text-bodyColor py-2 sm:py-4  text-sm xxs:text-base sm:text-xl font-primaryMedium">
We not only help you set-up your solar system, we also offer customizable solar panels as per your needs. Install no more no less, only what you need.</p>
</div>
              </div>
              <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row pt-8 xxs:pt-12 2md:pt-20 sm:px-8">
              <div className="mx-auto sm:mx-0 w-1/3 sm:w-1/5">
<img src="./images/energy-3.png" className="object-contain rounded-full"/>
</div>
<div className="sm:w-4/5 sm:pl-6 xl:pl-20 container m-auto">
<h1 className="text-xl xxs:text-2xl 2md:text-3xl text-titleColor font-primarySemiBold">
Certified Products with warranty
</h1>
<p className="text-bodyColor py-2 sm:py-4  text-sm xxs:text-base sm:text-xl font-primaryMedium">
Our products come with certifications from the top brands like CEC, TUV sud, IEC OHSAS, etc. You can rely on our top notch install crews and product quality.</p>
</div>
              </div>
              </div>
        </div>
      </div>
    */}
      <section className="bg-white">
        <div className="container m-auto lg:px-10 pb-12 py-2 lg:py-20">
          <h1 className="px-6 pb-4 md:pb-14 text-2xl xxs:text-3xl sm:text-4xl 2md:text-5xl xxs:text-center text-titleColor font-primaryMedium xl:w-3/4 mx-auto">
            Fuel your vehicle with <span className="font-primaryBold">reliable clean energy</span></h1>
          <div className="md:hidden xl:mx-20 xl:px-10 px-6 2md:mx-4 2md:px-4 space-y-12">
            <Carousel responsive={responsive} showDots={true} arrows={false}>
              <div className="grid md:grid-cols-2 gap-6 grid-cols-1">
                <Fade triggerOnce delay={500}>                  
                  <div className=" md:bg-white">
                    <img
                      src="./images/panel-charger.png"
                      className="object-contain md:bg-white md:m-auto"
                    />
                  </div>
                </Fade>
                <div className="">
                  <h2 className="text-titleColor text-xl xxs:text-2xl font-primaryMedium pb-2">
                    Hassle free Installation
                  </h2>
                  <p className="text-gray-500 font-primaryMedium text-base pb-8 xxs:pb-6">
                    From helping you choose the right solar panels to the right EV Charger for your
                    home, we will do all the heavy lifting for you. You can even manage your solar
                    system on your device and get help from our support team whenever you need.
                  </p>
                </div>
              </div>

              <div className="md:grid md:grid-cols-2 gap-6 flex flex-col-reverse">
                <div className="">
                  <h2 className="text-titleColor text-xl xxs:text-2xl font-primaryMedium pb-2">
                    Custom Solar
                  </h2>
                  <p className="text-gray-500 font-primaryMedium text-base pb-8 xxs:pb-6">
                    Solar Quote will not only help you set-up & install your solar system, we also help you design
                    a solar system that meets all of your energy requirements.
                  </p>
                </div>
                <Fade triggerOnce delay={500}>                  
                  <div className=" md:bg-white">
                    <img
                      src="./images/panel-house.png"
                      className="object-contain md:bg-white md:m-auto"
                    />
                  </div>
                </Fade>
              </div>

              <div className="grid md:grid-cols-2 gap-6 grid-cols-1">
              <Fade triggerOnce delay={500}>                  
                  <div className=" md:bg-white">
                    <img
                      src="./images/businessmen-shaking-hands.png"
                      className="object-contain md:bg-white md:m-auto"
                    />
                  </div>
                </Fade>
                <div className="">
                  <h2 className="text-titleColor text-xl xxs:text-2xl font-primaryMedium pb-2">
                    Certified Products with warranty
                  </h2>
                  <p className="text-gray-500 font-primaryMedium text-base pb-8 xxs:pb-6">
                    Our products come with certifications from the top brands like <span className="font-primaryBold">
                      CEC, TUV sud, IEC OHSAS, etc. (any recognizable names we can use?)</span> You can rely on our
                    top notch install crews and product quality.
                  </p>
                </div>
              </div>
            </Carousel>
          </div>

          <div className="hidden md:block xl:mx-20 xl:px-10 px-6 2md:mx-4 2md:px-4 space-y-12">
            <div className="grid md:grid-cols-2 gap-14 grid-cols-1">
              <div className=" md:bg-white">
              <Fade triggerOnce delay={500}>                  
                  <img
                    src="./images/panel-charger.png"
                    className="object-contain w-11/12"
                  /></Fade>
              </div>
              <div className="my-auto">
                <h2 className="lg:w-3/4 text-titleColor text-xl xxs:text-2xl 2xl:text-3xl font-bold pb-3">
                  Hassle free Installation
                </h2>
                <p className="text-gray-500 font-primaryMedium text-base xl:text-lg line-height">
                  From helping you choose the right solar panels to the right EV Charger for your
                  home, we will do all the heavy lifting for you. You can even manage your solar
                  system on your device and get help from our support team whenever you need.
                </p>
              </div>
            </div>

            <div className="md:grid md:grid-cols-2 gap-14 flex flex-col-reverse">
              <div className="my-auto">
                <h2 className="lg:w-3/4 text-titleColor text-xl xxs:text-2xl 2xl:text-3xl font-bold pb-3">
                  Custom Solar
                </h2>
                <p className="text-gray-500 font-primaryMedium text-base xl:text-lg line-height">
                  Solar Quote will not only help you set-up & install your solar system, we also help you design
                  a solar system that meets all of your energy requirements.
                </p>
              </div>
              <div className=" md:bg-white">
              <Fade triggerOnce delay={500}>                  
                  <img
                    src="./images/panel-house.png"
                    className="object-contain w-11/12"
                  /></Fade>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-14 grid-cols-1">
              <div className=" md:bg-white">
              <Fade triggerOnce delay={500}>                  <img
                    src="./images/businessmen-shaking-hands.png"
                    className="object-contain w-11/12"
                  /></Fade>
              </div>
              <div className="my-auto">
                <h2 className="lg:w-3/4 text-titleColor text-xl xxs:text-2xl 2xl:text-3xl font-bold pb-3">
                  Certified Products with warranty
                </h2>
                <p className="text-gray-500 font-primaryMedium text-base xl:text-lg line-height">
                  Our products come with certifications from the top brands like <span className="font-primaryBold">
                    CEC, TUV sud, IEC OHSAS, etc. (any recognizable names we can use?)</span> You can rely on our
                  top notch install crews and product quality.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <div className="xl:px-20 bg-gray-100">
        <section className="py-8 md:py-20">
          <div className="px-6 pb-6 xxs:p-6 2md:p-4 xl:px-20 md:container md:m-auto grid 2md:grid-cols-2 gap-4 2md:gap-10">
            <div className="xl:pr-20 xxs:p-6 xl:p-0 my-auto">
              <h1 className="text-xl xxs:text-3xl tracking-wide capitalize text-primary font-primaryMedium">
                Smart Charge
              </h1>
              <div className="border bg-primary border-primary my-3 w-12"> </div>
              <h1 className="text-2xl xxs:text-3xl sm:text-4xl md:text-5xl xl:text-5xl text-titleColor font-primaryMedium w-11/12">Charge your car
                <span className="font-primaryBold"> at home </span>
              </h1>
              <p className="text-titleColor py-4 text-base xxs:text-xl font-primaryMedium">
                Smart home chargers enable you to charge your car at night to ensure you have full battery every morning for the day ahead. Residential chargers
                will charge your EV at about 7kWh, giving 15-30 miles range per hour of charge.
              </p>
              <a
                href=""
                className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-12 py-2 my-4 text-base md:text-lg 2xl:text-xl"
              >
                Get a Quote
              </a>
            </div>

            <Fade triggerOnce delay={500}>              
              <div className="xl:px-10 px-6 my-auto">
                <img src="./images/charger.png" className="object-contain mx-auto" />
              </div>
            </Fade>
          </div>
        </section>
      </div>

      <section className="bg-parallax-img get-instant-estimate py-12 relative">
        <div className="p-6 container m-auto md:px-8 xl:px-24 text-center">
          <h1 className="xxs:text-center text-2xl xxs:text-4xl 2xl:text-5xl tracking-wide text-white font-primaryBold relative mb-4">
            Claim your free <span className="text-primary">solar estimate.</span>
          </h1>
          <a
            href="/"
            className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium sm:px-12 
     py-2.5 lg:py-2 my-4 text-base md:text-lg 2xl:text-xl w-3/4 sm:w-auto"
          >
            Grab now!
          </a>
        </div>
      </section>

      <section className="bg-white sm:pt-20 py-4">
        <div className="p-6 container m-auto md:px-4 xl:px-24">
          <div className="">
            <div className="">
              <h1 className="xxs:text-center text-2xl xxs:text-4xl 2xl:text-5xl tracking-wide text-titleColor font-primaryBold">
                Frequently Asked <span className="text-primary">Questions</span>
              </h1>
              <p className="mx-auto line-height2 xxs:text-center text-sm xxs:text-base md:text-lg 2xl:text-xl text-titleColor py-2 font-primaryRegular lg:max-w-lg">
                FAQ's answering questions related to solar panels,savings, and
                how solar works
              </p>
            </div>
            <div className="py-10 md:w-3/4 mx-auto">
              <FaqCharger />
            </div>
          </div>
        </div>
      </section>
      <section className="py-8 xxs:py-20 home contact-solar">
        <div className="py-4 px-8 xxs:py-4 xxs:px-4 container m-auto text-center xl:w-3/5">
          <FormGstEstimate />

          {/* <h1 className="tracking-tight 2xl:tracking-wide font-primaryMedium text-3xl xxs:text-4xl md:text-5xl text-white">
            Go Solar on Your Terms!
          </h1>
          <p className="tracking-wider text-white py-3 font-primaryMedium text-base xxs:text-lg md:text-xl">
            Take your first steps in creating a brighter future
          </p> */}

          {/* <form action="">
            <div className="grid sm:grid-cols-2 grid-cols-auto gap-4 xl:w-3/5 md:w-1/2 xxs:w-4/5 mx-auto py-4">
              <input
                type="text"
                placeholder="First Name"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Phone No"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Email"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="City"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Zip Code"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="State"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Job Type"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
            </div>
            <div>
              <ReactWOW
                animation="fadeIn"
              >
                <a
                  href=""
                  className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium sm:px-12 
     py-2.5 lg:py-2 my-4 text-base md:text-lg 2xl:text-xl w-3/4 sm:w-auto"
                >
                  Get Started Now
                </a>
              </ReactWOW>
            </div>
            <p className=" font-primaryRegular text-sm line-height2 text-gray-400  sm:w-3/4 mx-auto">
              By submitting this form, you consent to receive emails, text
              messages and phone calls at any phone number you provide, even if
              the number is a wireless number. You agree that such calls and
              texts may be made using automated technology and that you are not
              required to provide consent to these calls to make a purchase from
              us.
            </p>
          </form> */}
        </div>
      </section>

      {/* <footer>
        <div className="text-center bg-white">
          <p className="p-6 text-bodyColor font-medium text-base">
            &#169; 2021 Solar Quote. All rights reserved |&nbsp;
            <Link href="/privacy">
              <span className="text-gray-900 cursor-pointer ">
                {" "}
                Privacy Policy |
              </span>
            </Link>{" "}
            &nbsp;
            <span className="text-gray-900 ">(888) 708-3756</span>
          </p>
        </div>
      </footer>
       */}
      <Footer />
      <ToastContainer position="bottom-center" autoClose={8000}/>
    </Layout>

  );
};

export default Charger;
